// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".img-2[data-v-28312753]{top:-4.625rem;left:-1.25rem}@media(min-width:768px){.img-2[data-v-28312753]{top:-7.4375rem;left:-5rem}}.img-logo[data-v-28312753]{width:9rem}@media(min-width:768px){.img-logo[data-v-28312753]{width:10rem}}@media(min-width:768px){.content-col[data-v-28312753]{max-width:58.125%}}@media(min-width:768px){.content[data-v-28312753]{font-size:1.25rem;line-height:1.4}}", ""]);
// Exports
module.exports = exports;
